import './all-blocks';
import {registerSmartFormBlocks} from '@smartfire/gutenberg-react';
import './theme.scss';
import './i18n';
import registerColors from "./shared/colors";
import { isEditing } from "./shared/utils";

registerSmartFormBlocks();
if (isEditing()) {
    registerColors();
}
// Uncomment the following code to have a full PWA:
// const root = document.getElementById('root');
//
// if(root && root.childElementCount === 0) {
//     (async function(){
//         const [React, ReactDOM] = await Promise.all([(await import("react")), (await import("react-dom"))]);
//         const App = (await import("./App")).default;
//         ReactDOM.render(React.createElement(App, {}, null), root);
//     })()
// }

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PW
// (async () => {
//     const serviceWorker = await import("./serviceWorker");
//     serviceWorker.unregister();
// })();

